import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as urlTemplate from 'url-template';
import { environment } from '@environment';
import { TranslocoService } from '@jsverse/transloco';

import { SearchDataDefault, SearchDataDefaultType } from '@search-bar/entities/search-data-default';
import { searchBarApi } from '@search-bar/search-bar.api';
import { SelectAutocompletePlace } from '@search-bar/entities/select-autocomplete-place';
import { PlaceType } from '@shared/base-search-bar/entities/place-type';

@Injectable()
export class SearchDataService {

  constructor(
    private http: HttpClient,
    private translate: TranslocoService) { }

  public fetchDefaultPlaceFromIp(ip: string,
    type: SearchDataDefaultType,
    maxdistance: number = 500): Observable<SearchDataDefault> {
    return this.http.get<SearchDataDefault>(urlTemplate.parse(searchBarApi.ubication_ip.url).expand({
      ip: ip,
      lang: environment.language,
      distance: maxdistance,
      type: type
    }));
  }

  public fetchDefaultPlace(): Observable<SelectAutocompletePlace> {
    return of({
      code: this.getTranslate(`COUNTRIES.${environment.countryInfo.currency_code}.CODE`).toString(),
      description: this.getTranslate(`COUNTRIES.${environment.countryInfo.currency_code}.DESCRIPTION`).toString(),
      type: PlaceType.DEPARTURE,
      highlight_description: '',
      country: this.getTranslate(`COUNTRIES.${environment.countryInfo.currency_code}.COUNTRY`).toString(),
      state: this.getTranslate(`COUNTRIES.${environment.countryInfo.currency_code}.STATE`).toString()
    });
  }

  private getTranslate(key: string | string[]): string | string[] {
    return this.translate.translate(key);
  }
}
